<div>
    <div class="alert alert-danger alertMessageStyles80" role="alert" *ngIf="displayLoginFailure">
        <h5 class="H5Normal" style="display:inline">{{this.failureText}}</h5>
        <h5 class="H5Normal" style="display:inline;float:right;" (click)="HideLoginFailure()">X</h5>
    </div>
    <div class="alert alert-success alertMessageStyles80" role="alert" *ngIf="displaySuccessAlert">
        <h5 class="H5Normal" style="display:inline">{{this.successText}}</h5>
        <h5 class="H5Normal" style="display:inline;float:right;" (click)="HideSuccessAlert()">X</h5>
    </div>




    <div class="text-center whiteBackground" (mouseenter)="this.dotComService.DisplaySubMenu('')">

        <div *ngIf="!this.displayPasswordResetEmailPrompt" style="background-size: cover; background-position:center; padding-top:4.5vw; padding-bottom:4.5vw"
            [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'header-image.png)'}">
            <!-- <div class="row">
                <div class="d-xs d-lg-block col-lg-2 text-center"></div>
                <div class="col-xs-12 col-lg-8 text-start">
                    <a style="font-size:20pt; text-decoration: none !important"
                        href='/myharrellsaccountsetup'>
                        <h3 class="col-lg-8 d-inline DIN2014Regular greenBackground  whiteText"
                            style="padding:10px;font-size:20px; text-align: left;">ACCOUNT SETUP</h3>
                    </a>
                </div>
                <div class="d-xs d-lg-block col-lg-2 text-center"></div>
            </div> -->

            <div class="row" style="padding-top:10%">
                <div class="d-xs d-lg-block col-lg-4 text-center" ></div>
                <div class="col-lg-4 text-start"><img style="width:50%"
                        src="{{this.baseImagePaths + 'harrells-logo-footer.png'}}" alt="Harrells Footer Logo"></div>
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row pt-3">
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
                <H3 class="col-lg-4 DIN2014Regular whiteText"
                    style="text-align: left;font-size: 26px; line-height: 30px;">Login To Your Account</H3>
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row">
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
                <h3 class="col-lg-4 DIN2014Regular whiteText"
                    style="text-align: right; font-size: 19px; line-height: 20px; cursor: pointer; padding-top:20px; text-decoration: underline ;font-weight: 700;
    letter-spacing: .38px;"
                    (click)="CreateAccount()">Create An Account</h3>
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row">
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
                <h5 class="col-lg-4" style="display:inline; margin-bottom:0px"><input Class="DIN2014Regular" [(ngModel)]="email"
                        style="width:100%;padding: 17px 22px; line-height: 20px; font-size: 19px" placeholder="Email">
                </h5>
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row" style="margin-top: 16px;">
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
                <h5 class="col-lg-4" style="display:inline"><input type="password" Class="DIN2014Regular"
                        [(ngModel)]="password"
                        style="width:100%;padding: 17px 22px; line-height: 20px; font-size: 19px;"
                        placeholder="Password">
                </h5>
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row">
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
                <h3 class="col-lg-4 DIN2014Regular whiteText"
                    style="text-align: right; font-size: 19px; line-height: 20px; cursor: pointer;font-weight: 700; letter-spacing: .38px; padding-top:5px"
                    (click)="ResetPassword()">Forgot Password?</h3>
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row" style="padding-bottom:10%">
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
                <a class="col-lg-4"
                    style="padding:10px;font-size:20px; text-decoration: none !important;text-align:left;cursor: pointer;"
                    (click)="SubmitClicked()">
                    <h3 class=" DIN2014Regular whiteText blueBackground"
                        style="display:inline;text-align: left;padding:10px;font-size:20px;font-weight: 700;">SUBMIT</h3>
                </a>


                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            </div>
        </div>



        <div *ngIf="this.displayPasswordResetEmailPrompt">
            <div class="row pt-5">
                <div class="d-xs d-lg-block col-lg-2 text-center"></div>
                <h3 class="col-lg-8 DIN2014Regular blackText" style="text-align: left; font-size: 18pt;"
                    (click)="ResetPassword()">Forgot your Password? Please type the email address you used to sign into
                    myHarrell's and click the send button. We'll send you an email with instructions on how to reset
                    your password.</h3>
                <div class="d-xs d-lg-block col-lg-2 text-center"></div>
            </div>
            <div class="row mt-5">
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
                <h5 class="col-lg-4" style="display:inline"><input Class="DIN2014Regular" [(ngModel)]="resetEmail"
                        style="width:100%;padding-left:10pt;font-size:18pt;line-height: 3;" placeholder="EMAIL">
                </h5>
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row pt-5">
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
                <h3 class="col-lg-2 DIN2014Regular whiteText" style="text-align: left;"><a
                        class="DIN2014Bold blueBackground whiteText"
                        style="font-size:20pt;padding:8pt; text-decoration: none !important; cursor:pointer"
                        (click)="SubmitPasswordResetEmailClicked()">SUBMIT</a>
                    <a class="DIN2014Bold blueBackground whiteText"
                        style="margin-left:20px; font-size:20pt;padding:8pt; text-decoration: none !important; cursor:pointer"
                        (click)="CancelResetClicked()">CANCEL</a>
                </h3>
                <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            </div>
        </div>

    </div>
</div>